<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Perizinan Berusaha</h2>
    <Widget customHeader>
      <div v-if="user.role === 'Superuser'">
        <DataSuperUser ref="childTimTeknis" :itemsWithNumber="itemsWithNumber" :totalRows="totalRows" :rows="rows"
          :currentPage="currentPage" @onFiltered="onFiltered" @pilihModal="pilihModal" @deleteDokumen="deleteDokumen"
          @loaddata="loaddata" :dataJenisProyek="dataJenisProyek" :dataRisiko="dataRisiko"
          :dataSkalaUsaha="dataSkalaUsaha" :dataStatusVerdok="dataStatusVerdok" :user="user" :baseapiPengendalian="baseapiPengendalian" :dataReklamasi="dataReklamasi"
          :dataKlasifikasi="dataKlasifikasi" :dataKBLI="dataKBLI" />
      </div>
      <div v-else-if="user.role === 'Pemrakarsa'">
        <DataPemrakarsa ref="childTimTeknis" :itemsWithNumber="itemsWithNumber" :totalRows="totalRows" :rows="rows"
          :currentPage="currentPage" @onFiltered="onFiltered" @pilihModal="pilihModal" @deleteDokumen="deleteDokumen"
          @loaddata="loaddata" :dataJenisProyek="dataJenisProyek" :dataRisiko="dataRisiko"
          :dataSkalaUsaha="dataSkalaUsaha" :dataStatusVerdok="dataStatusVerdok" :user="user" :baseapiPengendalian="baseapiPengendalian" :dataReklamasi="dataReklamasi"
          :dataKlasifikasi="dataKlasifikasi" :dataKBLI="dataKBLI" />
      </div>
      <div v-else-if="user.role === 'Pejabat'">
        <DataPejabat ref="childTimTeknis" :itemsWithNumber="itemsWithNumber" :totalRows="totalRows" :rows="rows"
          :currentPage="currentPage" @onFiltered="onFiltered" @pilihModal="pilihModal" @deleteDokumen="deleteDokumen"
          @loaddata="loaddata" :dataJenisProyek="dataJenisProyek" :dataRisiko="dataRisiko"
          :dataSkalaUsaha="dataSkalaUsaha" :dataStatusVerdok="dataStatusVerdok" :user="user" :baseapiPengendalian="baseapiPengendalian" :dataReklamasi="dataReklamasi"
          :dataKlasifikasi="dataKlasifikasi" :dataKBLI="dataKBLI" />
      </div>
    </Widget>

    <!-- modal lengkap tambah dokumen -->
    <b-modal body-class="bg-white" id="modal-lengkap" title="Tambah Permohonan" cancel-title="Close" ok-title="Accept"
      size="fullscreen" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-overlay :show="show" rounded="sm" @shown="onShown" @hidden="onHidden">
              <b-card :aria-hidden="show ? 'true' : null">

                <b-card-text>Silahkan cari Permohonan dengan input NIB/NPWP/NIK dan Nomor Permohonan dari
                  OSS.</b-card-text>

                <b-row>

                  <b-col md="6">
                    <b-input-group>
                      <template #prepend>
                        <b-form-select v-model="filterPencarian">
                          <option value="nib">NIB</option>
                          <option value="npwp">NPWP</option>
                          <option value="nik">NIK</option>
                        </b-form-select>
                      </template>

                      <b-form-input type="text" :placeholder="`Masukkan ${filterPencarian.toUpperCase()}`"
                        v-model="dataSearch.value"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-input type="text" placeholder="Masukkan Nomor Permohonan"
                      v-model="dataSearch.nomor_permohonan"></b-form-input>
                  </b-col>
                  <b-col md="12">
                  </b-col>

                </b-row>

              </b-card>
              <template #overlay>
                <div class="text-center">
                  <!-- <div class="animate-bounce">
                  <i class="fa fa-search" ></i>
                </div> -->

                  <!-- <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon> -->
                  <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
                  <p id="cancel-label">Harap tunggu...</p>
                  <!-- <b-button
                  ref="cancel"
                  variant="outline-danger"
                  size="sm"
                  aria-describedby="cancel-label"
                  @click="show = false"
                >
                  Cancel
                </b-button> -->
                </div>
              </template>
            </b-overlay>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-card>
              <b-row>
                <b-card-text>Input Manual</b-card-text>
                <hr>
                <b-col md="6">
                  <b-form-group label="Sektor: *" label-for="Sektor">
                    <v-select id="default-select" v-model="dataPerDokumen.klasifikasi_pemohon"
                      :reduce="(klasifikasi) => klasifikasi.nama" label="nama" :options="dataKlasifikasi"
                      v-validate="'required'" name="Sektor" :class="{
                        'is-invalid': errors.has('form-1.Sektor'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-1.Sektor')">
                      {{ errors.first("form-1.Sektor") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Tanggal Proses: *" label-for="tanggal_proses">
                    <input type="date" v-validate="'required'" name="Tanggal Proses" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Tanggal Proses'),
                    }" v-model="dataPerDokumen.tanggal_proses" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Proses')">
                      {{ errors.first("form-1.Tanggal Proses") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Bentuk Usaha: *" label-for="username">
                    <b-form-select v-model="dataPerDokumen.bentuk_usaha" v-validate="'required'" name="Bentuk Usaha"
                      :class="{ 'is-invalid': errors.has('form-1.Bentuk Usaha') }"
                      :options="optionsBentukUsaha"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-1.Bentuk Usaha')">
                      {{ errors.first("form-1.Bentuk Usaha") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tipe Permohonan: *" label-for="tipe_permohonan">
                    <b-form-select v-model="dataPerDokumen.tipe_permohonan" v-validate="'required'"
                      name="Tipe Permohonan" :class="{ 'is-invalid': errors.has('form-1.Tipe Permohonan') }"
                      :options="optionsTipe"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-1.Tipe Permohonan')">
                      {{ errors.first("form-1.Tipe Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPerDokumen.tipe_permohonan == 'Multi KBLI'">
                  <b-form-group label="Tipe Multi KBLI: *" label-for="Tipe Multi KBLI">
                    <b-form-select v-model="dataPerDokumen.tipe_multi_kbli" v-validate="'required'"
                      name="Tipe Multi KBLI" :class="{ 'is-invalid': errors.has('form-1.Tipe Multi KBLI') }"
                      :options="optionsMultiKBLI"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-1.Tipe Multi KBLI')">
                      {{ errors.first("form-1.Tipe Multi KBLI") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPerDokumen.tipe_multi_kbli == 'Mengikuti'">
                  <b-form-group label="Nomor Permohonan Utama: *" label-for="username">
                    <b-form-input v-validate="'required'" name="Nomor Permohonan Utama" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Permohonan Utama'),
                    }" id="name" type="text" v-model="dataPerDokumen.nomor_permohonan_utama" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan Utama')">
                      {{ errors.first("form-1.Nomor Permohonan Utama") }}
                    </span>

                    <span class="text-danger" v-if="status_nomor_error">
                      {{ "Nomor Permohonan utama tidak ditemukan, silahkan cek kembali" }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Kategori Permohonan: *" label-for="kategori">
                    <b-form-select v-model="dataPerDokumen.kategori_permohonan" v-validate="'required'" name="Kategori"
                      :class="{ 'is-invalid': errors.has('form-1.Kategori') }"
                      :options="optionsKategori"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-1.Kategori')">
                      {{ errors.first("form-1.Kategori") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="dataPerDokumen.kategori_permohonan == 'Penambahan KBLI'">
                  <b-form-group label="Nomor Permohonan Pendahulu: *" label-for="username">
                    <b-form-input v-validate="'required'" name="Nomor Permohonan Pendahulu" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Permohonan Pendahulu'),
                    }" id="name" type="text" v-model="dataPerDokumen.nomor_permohonan_pendahulu" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan Pendahulu')">
                      {{ errors.first("form-1.Nomor Permohonan Pendahulu") }}
                    </span>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-card>
          </b-col>
        </b-row>


        <b-row>
          <b-col md="12">
            <b-card>
              <b-card-text>Input Otomatis</b-card-text>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Nama Pemohon: *" label-for="Nama Pemohon">
                    <b-form-input v-validate="'required'" name="Nama Pemohon" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nama Pemohon'),
                    }" id="name" type="text" v-model="dataPerDokumen.nama_pemohon" />
                    <span class="text-danger" v-if="errors.has('form-1.Nama Pemohon')">
                      {{ errors.first("form-1.Nama Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="NIK Pemohon: *" label-for="NIK Pemohon">
                    <b-form-input v-validate="'required'" name="NIK Pemohon" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.NIK Pemohon'),
                    }" id="name" type="text" v-model="dataPerDokumen.nik_pemohon" />
                    <span class="text-danger" v-if="errors.has('form-1.NIK Pemohon')">
                      {{ errors.first("form-1.NIK Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Email Pemohon: *" label-for="Email Pemohon">
                    <b-form-input v-validate="'required'" name="Email Pemohon" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Email Pemohon'),
                    }" v-model="dataPerDokumen.email_pemohon" type="email" />
                    <span class="text-danger" v-if="errors.has('form-1.Email Pemohon')">
                      {{ errors.first("form-1.Email Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Alamat Pemohon: *" label-for="Alamat Pemohon">
                    <b-form-textarea v-validate="'required'" name="Alamat Pemohon" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Alamat Pemohon'),
                    }" v-model="dataPerDokumen.alamat_pemohon" type="email" />
                    <span class="text-danger" v-if="errors.has('form-1.Alamat Pemohon')">
                      {{ errors.first("form-1.Alamat Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Nomor Permohonan: *" label-for="Nomor Permohonan">
                    <b-form-input v-validate="'required'" name="Nomor Permohonan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Permohonan'),
                    }" v-model="dataPerDokumen.nomor_permohonan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan')">
                      {{ errors.first("form-1.Nomor Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>


                <b-col md="6">
                  <b-form-group label="NPWP: *" label-for="NPWP">
                    <b-form-input v-validate="'required'" name="NPWP" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.NPWP'),
                    }" v-model="dataPerDokumen.npwp_pemohon" type="text" v-mask="'##.###.###.#-###.####'" />
                    <span class="text-danger" v-if="errors.has('form-1.NPWP')">
                      {{ errors.first("form-1.NPWP") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="NIB: *" label-for="NIB">
                    <b-form-input v-validate="'required'" name="NIB" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.NIB'),
                    }" v-model="dataPerDokumen.nib_pemohon" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.NIB')">
                      {{ errors.first("form-1.NIB") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="No Proyek: *" label-for="No Proyek">
                    <b-form-input v-validate="'required'" name="No Proyek" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.No Proyek'),
                    }" type="text" v-model="dataPerDokumen.nomor_proyek" />
                    <span class="text-danger" v-if="errors.has('form-1.No Proyek')">
                      {{ errors.first("form-1.No Proyek") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="KBLI: *" label-for="KBLI">
                    <v-select id="default-select" v-model="dataPerDokumen.kbli" :reduce="(kbli) => kbli.kode"
                      label="kode_deskripsi" :options="dataKBLI" multiple v-validate="'required'" name="KBLI"
                      :class="{ 'is-invalid': errors.has('form-1.KBLI') }" />
                    <span class="text-danger" v-if="errors.has('form-1.KBLI')">
                      {{ errors.first("form-1.KBLI") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Skala Usaha *" label-for="Skala Usaha">
                    <v-select id="default-select" v-model="dataPerDokumen.skala_usaha"
                      :reduce="(skala_usaha) => skala_usaha.nama" label="nama" :options="dataSkalaUsaha"
                      v-validate="'required'" name="Skala Usaha"
                      :class="{ 'is-invalid': errors.has('form-1.Skala Usaha') }" />
                    <span class="text-danger" v-if="errors.has('form-1.Skala Usaha')">
                      {{ errors.first("form-1.Skala Usaha") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Tanggal Permohonan: *" label-for="Tanggal Permohonan">
                    <input type="date" v-validate="'required'" name="Tanggal Permohonan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Tanggal Permohonan'),
                    }" v-model="dataPerDokumen.tanggal_pada_permohonan" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Permohonan')">
                      {{ errors.first("form-1.Tanggal Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Jenis Kegiatan: *" label-for="Jenis Kegiatan">
                    <b-form-input v-model="dataPerDokumen.jenis_kegiatan" type="text" v-validate="'required'"
                      name="Jenis Kegiatan" :class="{
                        'form-control': true,
                        'is-invalid': errors.has('form-1.Jenis Kegiatan'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Kegiatan')">
                      {{ errors.first("form-1.Jenis Kegiatan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Lokasi: *" label-for="Lokasi">
                    <v-select id="default-select" v-model="dataPerDokumen.lokasi" :reduce="(kbli) => kbli.nama_provinsi"
                      label="nama_provinsi" :options="dataLokasi" v-validate="'required'" name="Lokasi"
                      :class="{ 'is-invalid': errors.has('form-1.Lokasi') }" />
                    <span class="text-danger" v-if="errors.has('form-1.Lokasi')">
                      {{ errors.first("form-1.Lokasi") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Nama Perairan: *" label-for="Nama Perairan">
                    <b-form-input v-validate="'required'" name="Nama Perairan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nama Perairan'),
                    }" type="text" v-model="dataPerDokumen.nama_perairan" />
                    <span class="text-danger" v-if="errors.has('form-1.Nama Perairan')">
                      {{ errors.first("form-1.Nama Perairan") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Jenis Proyek *" label-for="Jenis Proyek">
                    <v-select id="default-select" v-model="dataPerDokumen.jenis_proyek"
                      :reduce="(jenis_proyek) => jenis_proyek.nama" label="nama" :options="dataJenisProyek"
                      v-validate="'required'" name="Jenis Proyek"
                      :class="{ 'is-invalid': errors.has('form-1.Jenis Proyek') }" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Proyek')">
                      {{ errors.first("form-1.Jenis Proyek") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Risiko *" label-for="Risiko">
                    <v-select id="default-select" v-model="dataPerDokumen.risiko" :reduce="(risiko) => risiko.nama"
                      label="nama" :options="dataRisiko" v-validate="'required'" name="Risiko"
                      :class="{ 'is-invalid': errors.has('form-1.Risiko') }" />
                    <span class="text-danger" v-if="errors.has('form-1.Risiko')">
                      {{ errors.first("form-1.Risiko") }}
                    </span>
                  </b-form-group>
                </b-col>


                <!-- <b-col md="6">
                  <b-form-group label="PIC *">
                    <b-form-input v-validate="'required'" name="PIC"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.PIC') }" v-model="dataPerDokumen.pic" type="text"/>
                        <span class="text-danger" v-if="errors.has('form-1.PIC')">
                          {{ errors.first('form-1.PIC') }}
                        </span>
                  </b-form-group>
              </b-col> -->
                <!-- <b-col md="6">
                  <b-form-group label="Status Verifikasi Dokumen *">
                    <v-select
                      id="default-select"
                      v-model="dataPerDokumen.status_verdok"
                      label="nama"
                      index="nama"
                      :options="dataStatusVerdok" 
                      v-validate="'required'" name="Status Verifikasi Dokumen"
                      :class="{  'is-invalid': errors.has('form-1.Status Verifikasi Dokumen') }"
                    />
                    <span class="text-danger" v-if="errors.has('form-1.Status Verifikasi Dokumen')">
                      {{ errors.first('form-1.Status Verifikasi Dokumen') }}
                    </span>
                  </b-form-group>
              </b-col> -->


                <b-col md="6">
                  <b-form-group label="Reklamasi: *" label-for="Reklamasi">
                    <b-form-select v-model="dataPerDokumen.reklamasi" v-validate="'required'" name="Reklamasi"
                      :class="{ 'is-invalid': errors.has('form-1.Reklamasi') }"
                      :options="dataReklamasi"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-1.Reklamasi')">
                      {{ errors.first("form-1.Reklamasi") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="PSN: *" label-for="PSN">
                    <v-select id="default-select" v-model="dataPerDokumen.psn" :options="['PSN', 'Non PSN']"
                      v-validate="'required'" name="PSN" :class="{ 'is-invalid': errors.has('form-1.PSN') }" />
                    <span class="text-danger" v-if="errors.has('form-1.PSN')">
                      {{ errors.first("form-1.PSN") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Jenis Permohonan: *" label-for="Jenis Permohonan">
                    <v-select id="default-select" v-model="dataPerDokumen.jenis_pnbp" :options="[
                      'Area',
                      'Kabel Bawah Laut',
                      'Pipa Air Bersih / Air Baku',
                      'Pipa Selain Air Bersih / Air Baku',
                    ]" v-validate="'required'" name="Jenis Permohonan"
                      :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
                      {{ errors.first("form-1.Jenis Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPerDokumen.jenis_pnbp == 'Area' || dataPerDokumen.luas != null">
                  <b-form-group label="Luas (ha) *" label-for="Luas">
                    <b-form-input min="0" step=".01" type="number" name="Luas" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Luas'),
                    }" v-model="dataPerDokumen.luas" />
                    <span class="text-danger" v-if="errors.has('form-1.Luas')">
                      {{ errors.first("form-1.Luas") }}
                    </span>
                  </b-form-group>
                </b-col>

                <!-- <b-col
            md="6"
            v-if="
              dataPerDokumen.jenis_pnbp == 'Kabel Bawah Laut' ||
              dataPerDokumen.jenis_pnbp == 'Pipa Air Bersih / Air Baku' ||
              dataPerDokumen.jenis_pnbp == 'Pipa Selain Air Bersih / Air Baku'
            "
          >
            <b-form-group label="Panjang (di dalam Kws. Konservasi)(km)*">
              <b-form-input
                min="0"
                step=".01"
                type="number"
                name="Panjang (di dalam Kws. Konservasi)(km)"
                :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)'),
                }"
                v-model="dataPerDokumen.panjang_konservasi"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)')"
              >
                {{ errors.first("form-1.Panjang (di dalam Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col> -->
                <b-col md="6" v-if="
                  dataPerDokumen.jenis_pnbp == 'Kabel Bawah Laut' ||
                  dataPerDokumen.jenis_pnbp == 'Pipa Air Bersih / Air Baku' ||
                  dataPerDokumen.jenis_pnbp == 'Pipa Selain Air Bersih / Air Baku' ||
                  dataPerDokumen.panjang != null
                ">
                  <b-form-group label="Panjang *" label-for="Panjang">
                    <b-form-input min="0" step=".01" type="number" name="Panjang (di luar Kws. Konservasi)(km)" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPerDokumen.panjang_nonkonservasi" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang (di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="checkPermohonan(dataPerDokumen.nomor_permohonan_utama)">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal jadwal vertek -->

    <!-- modal pembayaran -->
    <b-modal body-class="bg-white" id="modal-pembayaran" title="Upload Tagihan" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <span v-if="
          dataPerDokumen.file_tagihan_i === null &&
          dataPerDokumen.file_tagihan_ii === null &&
          dataPerDokumen.file_tagihan_iii === null
        ">
          <legend><strong>Tagihan 1</strong></legend>
          <b-row>
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_i" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-1.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                  {{ errors.first("form-1.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_i" accept=".pdf"></b-form-file>
              </b-form-group>
              <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_i === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_i" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
            </b-col>
          </b-row>
        </span>
        <span v-else-if="
          dataPerDokumen.file_tagihan_i !== null &&
          dataPerDokumen.file_tagihan_ii === null &&
          dataPerDokumen.file_tagihan_iii === null
        ">
          <legend><strong>Tagihan 2</strong></legend>
          <b-row>
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_ii" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-1.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                  {{ errors.first("form-1.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_ii" accept=".pdf"></b-form-file>
              </b-form-group>
              <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_ii === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_ii" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
            </b-col>
          </b-row>
        </span>
        <span v-else>
          <legend><strong>Tagihan 3</strong></legend>
          <b-row>
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_iii" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-1.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                  {{ errors.first("form-1.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_iii" accept=".pdf"></b-form-file>
              </b-form-group>
              <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_iii === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_iii" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
            </b-col>
          </b-row>
        </span>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitPembayaran">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal body-class="bg-white" id="modal-invoice" title="Upload Invoice" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Invoice: *" label-for="username">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control"></b-form-file>
              <span class="text-danger" v-if="errors.has('form-1.PIC')">
                {{ errors.first("form-1.PIC") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitJadwal">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
table.table.b-table>thead>tr>th[aria-sort="ascending"]::after,
table.table.b-table>tfoot>tr>th[aria-sort="ascending"]::after {
  opacity: 1;
  content: "\2191";
}
</style>

<script>
import Widget from "@/components/Widget/Widget";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import DataSuperUser from "./DataDokumen/Superuser";
import DataPemrakarsa from "./DataDokumen/Pemrakarsa";
import DataPejabat from "./DataDokumen/Pejabat";
import toast from "../../../helper/toast";

export default {
  name: "Dynamic",
  components: {
    Widget,
    ClassicEditor,
    vSelect,
    DataSuperUser,
    DataPemrakarsa,
    DataPejabat,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem("baseapiPengendalian"),
      apiKey: localStorage.getItem("api-key"),
      user: JSON.parse(localStorage.getItem("userPengendalian")),
      columnsDatatable: [
        "no",
        "nama_pemohon",
        "nomor_permohonan",
        "jenis_kegiatan",
        "status_verdok",
        "tanggal_pada_permohonan",
        "aksi",
      ],
      show: false,
      dataPermohonan: [],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      filterPencarian: 'nib',
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_verdok", label: "Status", sortable: true },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        "Aksi",
      ],
      dataDokumen: [],
      wygEditor: ClassicEditor,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPerDokumen: [],
      dataUser: [],
      dataTTD: [],
      jenisPertemuan: "Langsung",
      optionsPrioritas: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataKBLI: [],
      dataLokasi: [],
      dataKlasifikasi: [],
      optionsBentukUsaha: [
        { value: 'BUMN', text: "BUMN" },
        { value: 'BUMD', text: "BUMD" },
        { value: 'Lainnya', text: "Lainnya" },
      ],
      optionsKategori: [
        { value: 'Permohonan Baru', text: "Permohonan Baru" },
        // { value: 'Penambahan KBLI', text: "Penambahan KBLI" },
        // { value: 'Notifikasi Izin Lokasi', text: "Notifikasi Izin Lokasi" },
      ],

      optionsTipe: [
        { value: 'Single KBLI', text: "Single KBLI" },
        { value: 'Multi KBLI', text: "Multi KBLI" },
      ],

      optionsMultiKBLI: [
        { value: 'Proses', text: "Proses" },
        { value: 'Mengikuti', text: "Mengikuti" },
      ],

      dataSearch: {
        value: null,
        nomor_permohonan: null
      },
      status_nomor_error: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    itemsWithNumber() {
      return this.dataPermohonan.map((d, index) => ({ ...d, no: index + 1 }));
    },

    rows() {
      return this.dataPermohonan.length;
    },
  },
  mounted() {
    // this.loaddata();
    this.totalRows = this.items.length;
    // this.getRisiko();
    // this.getJenisProyek();
    // this.getSkalaUsaha();
    // this.getStatusVerdok();
    // this.getDataTTD();
    // this.getKBLI();
    // this.getLokasi();
    // this.getKlasifikasi();
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetPNBP() {
      this.dataPerDokumen.luas = null
      this.dataPerDokumen.panjang_konservasi = null
      this.dataPerDokumen.panjang_nonkonservasi = null
    },

    // mendapatkan data jenis proyek
    getJenisProyek() {
      axios
        .get(this.baseapiPengendalian + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // mendapatkan data Provinsi
    getLokasi() {
      axios
        .get(this.baseapiPengendalian + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataLokasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

 // mendapatkan data kbli
    getKBLI() {
      axios
        .get(this.baseapiPengendalian + "api/kbli", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKBLI = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    //get Klasifikasi

    getKlasifikasi() {
      axios
        .get(this.baseapiPengendalian + "api/klasifikasi_pemohon", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKlasifikasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // delete dokumen
    deleteDokumen(id) {
      Swal.fire({
        title: "Hapus Data?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + `api/permohonan/` + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((res) => {
              toast.success(this, "Berhasil Dihapus");
              this.$refs.childTimTeknis.getdata();
              // this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err);
              toast.error(this,err.response.data.message);
              return err;
            });
        }
      });
    },

    // simpan dokumen lengkap
    onSubmit() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-lengkap");
          });
          axios
            .post(
              this.baseapiPengendalian + "api/permohonan",
              {
                nib_pemohon: this.dataPerDokumen.nib_pemohon,
                nik_pemohon: this.dataPerDokumen.nik_pemohon,
                alamat_pemohon: this.dataPerDokumen.alamat_pemohon,
                nama_pemohon: this.dataPerDokumen.nama_pemohon,
                email_pemohon: this.dataPerDokumen.email_pemohon,
                tanggal_pada_permohonan:
                  this.dataPerDokumen.tanggal_pada_permohonan,
                tangal_masuk_oss: this.dataPerDokumen.tanggal_proses,
                nomor_permohonan: this.dataPerDokumen.nomor_permohonan,
                nomor_proyek: this.dataPerDokumen.nomor_proyek,
                klasifikasi_pemohon: this.dataPerDokumen.klasifikasi_pemohon,
                kbli: this.dataPerDokumen.kbli,
                jenis_kegiatan: this.dataPerDokumen.jenis_kegiatan,
                lokasi: this.dataPerDokumen.lokasi,
                provinsi: this.dataPerDokumen.lokasi,
                nama_perairan: this.dataPerDokumen.nama_perairan,
                jenis_proyek: this.dataPerDokumen.jenis_proyek,
                risiko: this.dataPerDokumen.risiko,
                skala_usaha: this.dataPerDokumen.skala_usaha,
                jenis_pnbp: this.dataPerDokumen.jenis_pnbp,
                luas: this.dataPerDokumen.luas,
                panjang_konservasi: this.dataPerDokumen.panjang_konservasi,
                panjang_nonkonservasi:
                  this.dataPerDokumen.panjang_nonkonservasi,
                // status_verdok: "Dokumen Lengkap",
                tanggal_proses: this.dataPerDokumen.tanggal_proses,
                catatan_verdok: null,
                bentuk_usaha: this.dataPerDokumen.bentuk_usaha,
                reklamasi: this.dataPerDokumen.reklamasi,
                npwp_pemohon: this.dataPerDokumen.npwp_pemohon,
                psn: this.dataPerDokumen.psn,
                kategori_permohonan: this.dataPerDokumen.kategori_permohonan,
                tipe_permohonan: this.dataPerDokumen.tipe_permohonan,
                tipe_multi_kbli: this.dataPerDokumen.tipe_permohonan == 'Multi KBLI' ? this.dataPerDokumen.tipe_multi_kbli : "Proses",
                nomor_permohonan_utama: this.dataPerDokumen.tipe_permohonan == 'Multi KBLI' && this.dataPerDokumen.tipe_multi_kbli == 'Mengikuti' ? this.dataPerDokumen.nomor_permohonan_utama : null,
                nomor_permohonan_pendahulu: this.dataPerDokumen.kategori_permohonan == 'Penambahan KBLI' ? this.dataPerDokumen.nomor_permohonan_pendahulu : null,
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success(`<div style="display: flex; align-items: center;">
     <i class='fa fa-check-circle'></i>
     <span>Data berhasil ditambahkan</span>
   </div>`);
              // this.loaddata()
              this.$refs.childTimTeknis.getdata();
              this.dataPerDokumen = [];

              this.dataSearch.value = null
              this.dataSearch.nomor_permohonan = null

              this.status_nomor_error = false

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(`<div style="display: flex; align-items: center;">
     <i class='fa fa-times-circle'></i>
     <span>${err.response.data.message}</span>
   </div>`);
              return err;
            });
        } else {
          this.$toasted.error(`<div style="display: flex; align-items: center;">
     <i class='fa fa-times-circle'></i>
     <span>Pengisian belum lengkap. Mohon lengkapi seluruh data yang diperlukan.</span>
   </div>`)
        }
      });
    },

    // simpan dokumen tidak lengkap
    onSubmit2() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-tidak-lengkap");
          });
          axios
            .post(
              this.baseapiPengendalian + "api/permohonan",
              {
                nib_pemohon: this.dataPerDokumen.nib_pemohon,
                nama_pemohon: this.dataPerDokumen.nama_pemohon,
                email_pemohon: this.dataPerDokumen.email_pemohon,
                tanggal_pada_permohonan:
                  this.dataPerDokumen.tanggal_pada_permohonan,
                tangal_masuk_oss: this.dataPerDokumen.tanggal_proses,
                nomor_permohonan: this.dataPerDokumen.nomor_permohonan,
                nomor_proyek: this.dataPerDokumen.nomor_proyek,
                klasifikasi_pemohon: this.dataPerDokumen.klasifikasi_pemohon,
                kbli: this.dataPerDokumen.kbli,
                jenis_kegiatan: this.dataPerDokumen.jenis_kegiatan,
                lokasi: this.dataPerDokumen.lokasi,
                jenis_proyek: this.dataPerDokumen.jenis_proyek,
                risiko: this.dataPerDokumen.risiko,
                skala_usaha: this.dataPerDokumen.skala_usaha,
                jenis_pnbp: this.dataPerDokumen.jenis_pnbp,
                luas: this.dataPerDokumen.luas,
                panjang_konservasi: this.dataPerDokumen.panjang_konservasi,
                panjang_nonkonservasi: this.dataPerDokumen.panjang_nonkonservasi,
                pic: this.dataPerDokumen.pic,
                status_verdok: "Perbaikan Persyaratan",
                tanggal_proses: this.dataPerDokumen.tanggal_proses,
                catatan_verdok: this.dataPerDokumen.catatan_verdok,
                bentuk_usaha: this.dataPerDokumen.bentuk_usaha,
                id_admin: this.dataPerDokumen.id_admin,
                npwp_pemohon: this.dataPerDokumen.npwp_pemohon,
                psn: this.dataPerDokumen.psn,
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              // this.loaddata()
              this.$refs.childTimTeknis.getdata();
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    // simpan jadwal vertek
    onSubmitJadwal() {
      if (this.dataPerDokumen.jenis_pertemuan === "Langsung") {
        this.$validator.validateAll("form-1").then((result) => {
          if (result) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-jadwal");
            });
            this.$loading(true);
            axios
              .post(
                this.baseapiPengendalian + "api/permohonan/" + this.dataPerDokumen.id,
                {
                  jadwal_verifikasi_teknis:
                    this.dataPerDokumen.jadwal_verifikasi_teknis,
                  pic_id: this.dataPerDokumen.pic_id,
                  tanggal_lolos_verifikasi_administrasi:
                    this.dataPerDokumen.tanggal_lolos_verifikasi_administrasi,
                  jenis_pertemuan: this.dataPerDokumen.jenis_pertemuan,
                  alamat: this.dataPerDokumen.alamat,
                  url_bahan_rapat: this.dataPerDokumen.url_bahan_rapat,
                  penandatangan_undangan:
                    this.dataPerDokumen.penandatangan_undangan,
                  diundang_kl: this.dataPerDokumen.diundang_kl,
                  diundang_pemda: this.dataPerDokumen.diundang_pemda,
                  diundang_pemohon: this.dataPerDokumen.diundang_pemohon,
                  waktu_verifikasi_teknis:
                    this.dataPerDokumen.waktu_verifikasi_teknis,
                  meeting_id: this.dataPerDokumen.meeting_id,
                  passcode: this.dataPerDokumen.passcode,
                },
                {
                  // status_tandatangan_undangan: true,

                  headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((res) => {
                this.$loading(false);
                this.$toasted.success("Berhasil Ditambah");
                this.$refs.childAdmin.getdata();
                this.dataPerDokumen = [];
                // Wait until the models are updated in the UI

                // this.downloadUndangan(res.data.data.file_undangan)
                return res;
              })
              .catch((err) => {
                console.log(err);
                this.$loading(false);
                this.$toasted.error(err.response.data.message);
                return err;
              });
          }
        });
      } else {
        var alamat_baru;
        alamat_baru = {
          meet_id: this.dataPerDokumen.meet_id,
          passcode: this.dataPerDokumen.passcode,
        };
        this.$validator.validateAll("form-1").then((result) => {
          if (result) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-jadwal");
            });
            this.$loading(true);
            axios
              .post(
                this.baseapiPengendalian + "api/permohonan/" + this.dataPerDokumen.id,
                {
                  jadwal_verifikasi_teknis:
                    this.dataPerDokumen.jadwal_verifikasi_teknis,
                  pic_id: this.dataPerDokumen.pic_id,
                  tanggal_lolos_verifikasi_administrasi:
                    this.dataPerDokumen.tanggal_lolos_verifikasi_administrasi,
                  jenis_pertemuan: this.dataPerDokumen.jenis_pertemuan,
                  alamat: alamat_baru,
                  url_bahan_rapat: this.dataPerDokumen.url_bahan_rapat,
                  penandatangan_undangan:
                    this.dataPerDokumen.penandatangan_undangan,
                  diundang_kl: this.dataPerDokumen.diundang_kl,
                  diundang_pemda: this.dataPerDokumen.diundang_pemda,
                  diundang_pemohon: this.dataPerDokumen.diundang_pemohon,
                  waktu_verifikasi_teknis:
                    this.dataPerDokumen.waktu_verifikasi_teknis,
                },
                {
                  // status_tandatangan_undangan: true,

                  headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((res) => {
                this.$loading(false);
                this.$toasted.success("Berhasil Ditambah");
                this.$refs.childAdmin.getdata();
                this.dataPerDokumen = [];

                // Wait until the models are updated in the UI
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-jadwal");
                });
                // setTimeout(() => {
                //     window.open(res.data.data.file_undangan, '_blank');
                // })
                this.downloadUndangan(res.data.data.file_undangan);
                return res;
              })
              .catch((err) => {
                this.$loading(false);
                console.log(err);
                this.$toasted.error(err.response.data.message);
                return err;
              });
          }
        });
      }
    },

    downloadUndangan(url) {
      console.log(url);
      window.open(url, "_blank");
      console.log("test");
    },

    // upload pembayaran
    onSubmitPembayaran() {
      console.log("cok");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-pembayaran");
      });
      this.$loading(true);
      let formData = new FormData();
      if (
        this.dataPerDokumen.tanggal_tagihan_ii === null &&
        this.dataPerDokumen.tanggal_tagihan_iii === null
      ) {
        formData.append("file_tagihan_i", this.dataPerDokumen.tagihan_i);
        formData.append(
          "tanggal_tagihan_i",
          this.dataPerDokumen.tanggal_tagihan_i
        );
      } else if (this.dataPerDokumen.tanggal_tagihan_iii === null) {
        formData.append("file_tagihan_i", this.dataPerDokumen.tagihan_i);
        formData.append(
          "tanggal_tagihan_i",
          this.dataPerDokumen.tanggal_tagihan_i
        );
        formData.append("file_tagihan_ii", this.dataPerDokumen.tagihan_ii);
        formData.append(
          "tanggal_tagihan_ii",
          this.dataPerDokumen.tanggal_tagihan_ii
        );
      } else {
        formData.append("file_tagihan_i", this.dataPerDokumen.tagihan_i);
        formData.append(
          "tanggal_tagihan_i",
          this.dataPerDokumen.tanggal_tagihan_i
        );
        formData.append("file_tagihan_ii", this.dataPerDokumen.tagihan_ii);
        formData.append(
          "tanggal_tagihan_ii",
          this.dataPerDokumen.tanggal_tagihan_ii
        );
        formData.append("file_tagihan_iii", this.dataPerDokumen.tagihan_iii);
        formData.append(
          "tanggal_tagihan_iii",
          this.dataPerDokumen.tanggal_tagihan_iii
        );
      }

      axios
        .post(
          this.baseapiPengendalian + "api/permohonan/uploadTagihan/" + this.dataPerDokumen.id,
          formData,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Ditambah");
          this.$refs.childBendahara.getdata();
          this.dataPerDokumen = [];

          // Wait until the models are updated in the UI
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          console.log(err);
          this.$toasted.error(err.response.data.message);
          // this.$bvModal.hide('modal-pembayaran')
          return err;
        });
    },

    // get data user
    getDataUser(data) {
      var api;
      if (data == "admin_kkp") {
        api = "api/user?filter=role,=,admin_kkp";
      } else {
        api = "api/user?filter=role,=,pic";
      }
      axios
        .get(this.baseapiPengendalian + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataUser = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDataTTD() {
      axios
        .get(this.baseapiPengendalian + "api/tandatangan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataTTD = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get data per id
    getDetailPerDokumen(id) {
      axios
        .get(this.baseapiPengendalian + "api/permohonan/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;

          let arrayKl = [];
          let arrayPemda = [];
          let arrayPemohon = [];
          let arrayAlamat = [];
          if (this.dataPerDokumen.diundang_kl != null) {
            arrayKl = this.dataPerDokumen.diundang_kl.split("||");
          }
          if (this.dataPerDokumen.diundang_pemda != null) {
            arrayPemda = this.dataPerDokumen.diundang_pemda.split("||");
          }
          if (this.dataPerDokumen.diundang_pemohon != null) {
            arrayPemohon = this.dataPerDokumen.diundang_pemohon.split("||");
          }

          // if (this.dataPerDokumen.alamat != null) {
          //   if (this.dataPerDokumen.alamat.includes('||') == true) {
          //     arrayAlamat = this.dataPerDokumen.alamat.split("||")

          //     this.dataPerDokumen['meet_id'] = arrayAlamat[0]
          //     this.dataPerDokumen['passcode'] = arrayAlamat[1]
          //   } else {
          //     this.dataPerDokumen.alamat = this.dataPerDokumen.alamat
          //   }
          // }

          // if (this.dataPerDokumen.alamat.includes('||') == true) {
          //   console.log('test')
          // }
          this.dataPerDokumen.diundang_kl = arrayKl;
          this.dataPerDokumen.diundang_pemda = arrayPemda;
          this.dataPerDokumen.diundang_pemohon = arrayPemohon;
          console.log(this.dataPerDokumen);
          this.$bvModal.show("modal-jadwal");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get risiko
    getRisiko() {
      axios
        .get(this.baseapiPengendalian + "api/risiko", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataRisiko = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get skala usaha
    getSkalaUsaha() {
      axios
        .get(this.baseapiPengendalian + "api/skala_usaha", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataSkalaUsaha = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get dokumen
    loaddata() {
      var api;
      if (this.user.role == "pic") {
        api = "api/permohonan?filter=pic_id,=," + this.user.id;
      } else if (this.user.role == "admin_kkp") {
        api = "api/permohonan?filter=id_admin,=," + this.user.id;
      } else {
        api = "api/permohonan";
      }
      axios
        .get(this.baseapiPengendalian + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get status verdok
    getStatusVerdok() {
      axios
        .get(this.baseapiPengendalian + "api/status_verdok", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataStatusVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // verif pembayaran buka modal
    verifPembayaran(id) {
      axios
        .get(this.baseapiPengendalian + "api/permohonan/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          this.dataPerDokumen["tagihan_i"] = this.dataPerDokumen.file_tagihan_i;
          this.dataPerDokumen["tagihan_ii"] =
            this.dataPerDokumen.file_tagihan_ii;
          this.dataPerDokumen["tagihan_iii"] =
            this.dataPerDokumen.file_tagihan_iii;
          console.log(this.dataPerDokumen);
          Swal.fire({
            title: "Upload Tagihan",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ya",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$bvModal.show("modal-pembayaran");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    pilihModal(data) {
      this.getDataUser(data);
      this.$bvModal.show("modal-lengkap");
    },

    onShown() {
      // Focus the cancel button when the overlay is showing
      this.$refs.cancel.focus()
    },
    onHidden() {
      // Focus the show button when the overlay is removed
      this.$refs.show.focus()
    },
    checkPermohonan(nomor_permohonan) {
      if(this.dataPerDokumen.tipe_multi_kbli == 'Mengikuti'){
        axios
        .get(this.baseapiPengendalian + "api/permohonan?filter=nomor_permohonan,=," + nomor_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          if (response.data.data.length > 0) {
            this.onSubmit()
          }else{
            this.status_nomor_error = true
            toast.error(this, "Nomor Permohonan utama tidak ditemukan, silahkan cek kembali")
          }
        })
        .catch((error) => {
          this.status_nomor_error = true
          toast.error(this, "Nomor Permohonan utama tidak ditemukan, silahkan cek kembali")
          console.log(error);
          return error;
        });
      }else{
      this.onSubmit()
    }
      
    }
  },
};
</script>

<style src="./Dokumen.scss" lang="scss" />
